import { Loader } from "@mantine/core";
import { HeldEmailDetail } from "../../../services/admin/systemEmails.service";
import { HeldEmailDetailContent } from "./HeldEmailDetailContent";
import { HeldEmailLoadError } from "./HeldEmailLoadError";

interface HeldEmailDetailDrawerBodyProps {
  detail?: HeldEmailDetail;
  error?: Error | null;
  loading: boolean;
  waitingTime: string;
}

export function HeldEmailDetailDrawerBody({
  detail,
  error,
  loading,
  waitingTime,
}: HeldEmailDetailDrawerBodyProps) {
  if (loading) return <Loader aria-label="Loading queued email" />;
  if (error)
    return <HeldEmailLoadError error={error} title="Email unavailable" />;
  return detail ? (
    <HeldEmailDetailContent detail={detail} waitingTime={waitingTime} />
  ) : null;
}
